// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2F2li","title":"styles_title__1U3pl"};